import { useEffect, useRef, type RefObject } from 'react';

import { bind } from 'bind-event-listener';

type Props = {
	handleClose: (
		event: Event | React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element> | null,
		currentLevel?: any,
	) => void;
	isOpen: boolean;
};

export function useClickToCloseRef({ isOpen, handleClose }: Props): RefObject<HTMLElement> {
	const ref = useRef<HTMLElement>(null);

	useEffect(() => {
		const el = ref.current;

		if (!el) {
			return;
		}

		const unbind = bind(el, {
			type: 'click',
			listener: (e: MouseEvent) => {
				if (isOpen) {
					e.stopPropagation();
					handleClose(e);
				}
			},
		});

		return unbind;
	}, [isOpen, handleClose]);

	return ref;
}
